import {
  DiagnosticResponseType,
  EndpointsItemsTypes,
  EndpointsLastEvaluatedKeyTypes,
  SearchEndpointsLastEvaluatedKeyTypes,
  ToggleEndpointsRequestPayload,
  ToggleEndpointsResponse,
} from 'interfaces'
import {AxiosResponse} from 'axios'
import {unwrapAPIError} from 'utils'
import {requestHandler} from '../HTTP'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'

const getEndpoints = async (data: {
  LastEvaluatedKey?:
    | EndpointsLastEvaluatedKeyTypes
    | SearchEndpointsLastEvaluatedKeyTypes
  sortBy?: string
  filterWith?: string
  filterText?: string[]
  sortAscending?: boolean
  limit?: number
}): Promise<
  AxiosResponse<{
    Items: EndpointsItemsTypes[]
    LastEvaluatedKey:
      | EndpointsLastEvaluatedKeyTypes
      | SearchEndpointsLastEvaluatedKeyTypes
    hasMore: boolean
  }>
> => {
  try {
    return await requestHandler<{
      Items: EndpointsItemsTypes[]
      LastEvaluatedKey:
        | EndpointsLastEvaluatedKeyTypes
        | SearchEndpointsLastEvaluatedKeyTypes
      hasMore: boolean
    }>({
      method: HttpMethods.POST,
      url: EndPoints.GetEndpoints,
      data: data,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const toggleEndpoint = async (
  data: ToggleEndpointsRequestPayload,
): Promise<AxiosResponse<ToggleEndpointsResponse>> => {
  try {
    return await requestHandler<ToggleEndpointsResponse>({
      method: HttpMethods.POST,
      url: EndPoints.ToggleEndpoint,
      data: {...data},
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getAssociatedUsers = async (data: {
  agentUUID: string
}): Promise<
  AxiosResponse<{
    users: {
      userId: string
      policyName: string
    }[]
  }>
> => {
  try {
    return await requestHandler<{
      users: {
        userId: string
        policyName: string
      }[]
    }>({
      method: HttpMethods.POST,
      url: EndPoints.GetAssociatedUsers,
      data: data,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getDiagnosticResult = async (data: {
  agent: string
}): Promise<AxiosResponse<DiagnosticResponseType>> => {
  try {
    return await requestHandler<DiagnosticResponseType>({
      method: HttpMethods.POST,
      url: EndPoints.GetDiagnosticResult,
      data: data,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const MonolithService = {
  getEndpoints,
  toggleEndpoint,
  getAssociatedUsers,
  getDiagnosticResult,
}
